import { AuthContextProps } from 'oidc-react';
import { appRoles, MISSING_ROLES_CLAIM_ERROR } from './auth.constants';
import { decodeJwtPayload } from './jwt-payload.utils';
import { subscribeToSessionRejection } from './session-rejection.service';
import { signOutAndClearDevice } from './sign-out.service';

export const getMostPrivilegedRole = (userRoles: string[]) => {
  // Create an array from appRoles values ordered by privilege
  const orderedRoles = Object.values(appRoles);
  // Initialize the most privileged role as null
  let mostPrivilegedRole: string | null = null;

  // Iterate through user roles
  userRoles.forEach(userRole => {
    const userRoleIndex = orderedRoles.indexOf(userRole);
    const mostPrivilegedRoleIndex = mostPrivilegedRole
      ? orderedRoles.indexOf(mostPrivilegedRole)
      : -1;
    if (
      userRoleIndex !== -1 &&
      (userRoleIndex < mostPrivilegedRoleIndex || mostPrivilegedRole === null)
    ) {
      mostPrivilegedRole = userRole;
    }
  });
  return mostPrivilegedRole;
};

export const getRolesFromAccessToken = (accessToken: string): string[] => {
  const roles = decodeJwtPayload(accessToken).roles;
  if (!Array.isArray(roles)) {
    throw new TypeError(MISSING_ROLES_CLAIM_ERROR);
  }
  return roles.map(String);
};

export const clearDeviceWhenSessionEnds = (auth: AuthContextProps): VoidFunction => {
  const signOut = () => void signOutAndClearDevice(auth);
  const { events } = auth.userManager;

  events.addSilentRenewError(signOut);
  events.addAccessTokenExpired(signOut);
  const unsubscribeFromRejection = subscribeToSessionRejection(signOut);

  return () => {
    events.removeSilentRenewError(signOut);
    events.removeAccessTokenExpired(signOut);
    unsubscribeFromRejection();
  };
};
